import React, { useMemo } from 'react';
import { Trans } from 'react-i18next';
import { getReadingTimeMinutes } from '../../Thumb/helpers';
var ReadingTime = function (_a) {
    var deviation = _a.deviation;
    var readingTime = useMemo(function () { return getReadingTimeMinutes(deviation.textContent); }, [deviation.textContent]);
    /* prettier-ignore */
    return (React.createElement(Trans, { i18nKey: "deviationview.journal.readingTime", count: readingTime },
        { readingTime: readingTime },
        " min"));
};
ReadingTime.displayName = 'ReadingTime';
export default ReadingTime;
//# sourceMappingURL=ReadingTime.js.map